import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { AddCall } from 'src/providers/addvCall';
import { ServicesProvider } from 'src/providers/services';

@Component({
  selector: 'app-doctor-service-list',
  templateUrl: './doctor-service-list.page.html',
  styleUrls: ['./doctor-service-list.page.scss'],
})
export class DoctorServiceListPage implements OnInit {

  servicesList: any;
  ServiceList: any;
  noData: boolean;

  constructor(
    public modalCtrl: ModalController,
    public services: ServicesProvider,
    public router: Router,
    public addCall: AddCall,
  ) { }

  ngOnInit() {}

  ionViewWillEnter() {
    //this.getServiceList();
  }

  dismiss() {
    this.modalCtrl.dismiss({
      id: ""
    });
  }
  selectedType(id) {
    this.modalCtrl.dismiss({
      id: id
    });
  }








  /* getServiceList() {
    try {
      let apiData = JSON.stringify({
        "doctor_id": window.localStorage['docID']
      });
      console.log("send Member Data=>10", JSON.parse(apiData));
      this.services.postRequestGndrl("doctor/getDoctorManageService", apiData).subscribe(res => {
        console.log(res);
        if(res.data.length > 0) {
          this.ServiceList = res.data;
          this.noData = false;
        } else {
          this.noData = true;
        }
      }, (err) => {
        alert(err);
      });
    } catch (err) {
      alert(err);
    };
  } */
}
